import Model, { encoders, ID, IsoDateTime, MODEL_LEVEL } from 'src/models/model'
import TipPool from 'src/models/tip/TipPool'
import TipPoolType from 'src/models/tip/TipPoolType'
import TipShare from 'src/models/tip/TipShare'

export default class TipPoolTip extends Model {
  static name = 'TipPoolTip'

  static level = MODEL_LEVEL.SITE

  static paginate = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Tipping]

  static define () {
    this.fields = {
      id: {
        type: ID
      },
      tipShare: {
        type: TipShare,
        default: null,
        output: true
      },
      tipPoolType: {
        type: TipPoolType,
        default: null,
        output: true
      },
      tipPool: {
        type: TipPool,
        default: null,
        output: true
      },
      state: {
        type: String,
        default: null,
        output: true
      },
      amount: {
        type: Number,
        encode: encoders.money,
        default: 0,
        output: true
      },
      paymentType: {
        type: String,
        default: null,
        output: true
      },
      paidAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      voidedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      distributingAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      distributedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      }
    }
  }
}
